{
  "name": "public-web",
  "version": "2.0.7",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration default --port 4100",
    "start:dev": "ng serve --configuration dev --port 4100",
    "start:test": "ng serve --configuration test --port 4100",
    "start:prod": "ng serve --configuration production --port 4100",
    "build": "ng build",
    "build:dev": "ng build --configuration dev",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration production",
    "build:default": "ng build --configuration default",
    "format": "prettier --write \"src/**/*.{html,scss,css,json}\" \"public/**/*.{html,scss,css,json}\" && eslint \"src/**/*.ts\" --fix",
    "lint": "eslint \"src/**/*.ts\"",
    "lint:fix": "eslint \"src/**/*.ts\" --fix",
    "watch": "ng build --watch --configuration test",
    "test": "ng test",
    "serve:ssr:public-web": "node dist/public-web/server/server.mjs",
    "serve:ssr:dev": "npm run build:dev && npm run serve:ssr:public-web",
    "serve:ssr:test": "npm run build:test && npm run serve:ssr:public-web",
    "serve:ssr:prod": "npm run build:prod && npm run serve:ssr:public-web",
    "serve:ssr": "npm run build:default && npm run serve:ssr:public-web"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-server": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@angular/service-worker": "^21.0.0",
    "@angular/ssr": "^21.0.0",
    "express": "^5.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.0.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@eslint/js": "^9.39.1",
    "@types/express": "^5.0.1",
    "@types/jasmine": "^5.1.13",
    "@types/node": "^20.17.19",
    "@typescript-eslint/eslint-plugin": "^8.48.0",
    "@typescript-eslint/parser": "^8.48.0",
    "autoprefixer": "^10.4.22",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "^10.1.8",
    "jasmine-core": "^5.12.1",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.49",
    "prettier": "^3.4.2",
    "tailwindcss": "^3.4.15",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.48.0"
  }
}
